import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import {
  USER_WITHDRAW_TO_CWALLET,
  USER_WITHDRAW_TO_NETWORK,
  USER_WITHDRAW_TO_RECORD,
  USER_WITHDRAW_TO_RECORD_LIST,
} from "@/config";
import { Trans } from "react-i18next";
import PostRequest from "@/components/PostRequest";

export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <div>
      {/* 用户提现到区块链 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="apis-related-to-user-withdrawals" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_39")}
            </Box>
            <Box id="user-withdrawals-to-blockchain" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_40")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_41")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_42")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_NETWORK} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "coinId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "address",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_43")}`,
                },
                {
                  name: "memo",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_withdraw_to_network"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 用户提现到区块链 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_network"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* Webhook 通知 - User Withdrawal */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box id="webhook-notifications-user-withdrawal" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_47")}
            </Box>
            <Box className="desc code">
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"merchant_user_wallet_mode_API.text_7_"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-user-withdrawal-records"} className="link">
                    Just a placeholder
                  </a>
                </Trans>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_7"
                    ) as any,
                  }}
                />
              )}
            </Box>
            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_8")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "orderId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_44_"
                  )}`,
                },
                {
                  name: "userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              {translate("merchant_user_wallet_mode_API.text_50")}
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"merchant_user_wallet_mode_API.text_51"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-user-withdrawal-records"} className="link">
                    s
                  </a>
                  s
                </Trans>
              ) : (
                <div
                  className="code"
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_51"
                    ) as any,
                  }}
                />
              )}
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "UserWithdrawal",
  "msg": {
    "recordId": "2024031312073317...",
    "orderId": "6322851679858976",
    "userId": "6322718677975328",
    "coinId": 1891,
    "coinSymbol": "TETH",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 用户提现到Cwallet账户 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="user-withdrawals-to-cwallet-account" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_52")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_53")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_CWALLET} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "coinId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "cwalletUser",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_54"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_55")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_55_" : "text_44"
                    }`
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_withdraw_to_cwallet"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 用户提现到Cwallet账户 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_55_1" : "text_46"
                    }`
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_56"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_cwallet"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-withdrawal-records" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_57")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_58")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },

                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_59"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_withdraw_to_record"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "cwalletUser",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_54"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_66_"
                  )}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_66")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_67")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_68")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_68_1" : "text_44_"
                    }`
                  ),
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "data.record.fee",
                  type: "Object",
                  desc: `${translate("merchant_user_wallet_mode_API.text_69")}`,
                },
                {
                  name: "data.record.fee.coinId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_92")}`,
                },
                {
                  name: "data.record.fee.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_70")}`,
                },
                {
                  name: "data.record.fee.amount",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_71")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现历史记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-withdrawal-history" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_72")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_73")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "toAddress",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_31"
                  ) as any,
                }}
              />
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_32"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={
              codeMap["user_withdraw_to_record_list"][language].http_ex_code
            }
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现历史记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.records[index].userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].withdrawType",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_64_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_63")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_64")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_44_1" : "text_44_"
                    }`
                  ),
                },
                {
                  name: "cwalletUser",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_65")}`,
                },
                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_74_"
                  )}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_74")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_75")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_68_"
                  )}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            "merchant_user_wallet_mode_API.text_30"
                          )},${translate(
                            "merchant_user_wallet_mode_API.text_32"
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
                {
                  name: "data.records[index].fee",
                  type: "Object",
                  desc: `${translate("merchant_user_wallet_mode_API.text_69")}`,
                },
                {
                  name: "data.records[index].fee.coinId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_92")}`,
                },
                {
                  name: "data.records[index].fee.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_70")}`,
                },
                {
                  name: "data.records[index].fee.amount",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_71")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
